// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
export default (input: string) => input.charAt(0).toUpperCase() + input.substring(1);
